import React from 'react'

const Magnify: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.5 0C10.09 0 13 2.91 13 6.5c0 1.434-.464 2.759-1.25 3.834l3.907 3.909-1.414 1.414-3.91-3.907C9.26 12.536 7.934 13 6.5 13 2.91 13 0 10.09 0 6.5S2.91 0 6.5 0zm0 2C4.015 2 2 4.015 2 6.5S4.015 11 6.5 11 11 8.985 11 6.5 8.985 2 6.5 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default Magnify
